module.exports = __webpack_public_path__ + "static/sample_car_left_front.bafe65f2.png";